<template>
  <section :class="['skill-dive-hero', isSkillDivePreSalePage && 'skill-dive-hero--pt-80']">
    <div
      :class="[
        'skill-dive-hero__content',
        isSkillDivePreSalePage && 'skill-dive-hero__content--mt-10',
      ]"
    >
      <div class="skill-dive-hero__logo">
        <img
          :src="skillDiveLogoBadge"
          alt="Skill Dive Experience"
          class="skill-dive-hero__logo-icon"
        />
      </div>
      <div class="skill-dive-hero__title">Unlock Potential with Skill Dive</div>
      <div class="skill-dive-hero__intro">
        Introducing a better way to prepare for real-world scenarios - immersive, curated labs that
        take you deeper into your training goals.
      </div>
      <div v-if="!isSkillDivePreSalePage" class="skill-dive-hero__learn-more">
        <router-link :to="{ name: 'skill-dive' }" class="btn btn--primary btn--full-mobile">
          Learn more
        </router-link>
      </div>
    </div>
    <div class="skill-dive-hero__icon">
      <img
        :src="skillDiveBadge"
        alt="Skill Dive Experience"
        :class="[
          'skill-dive-hero__icon-img',
          isSkillDivePreSalePage && 'skill-dive-hero__icon-img--top-65',
        ]"
      />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import skillDiveLogo from '@/assets/images/hero-section/skill-dive/skill-dive-logo.png'
import skillDiveIcon from '@/assets/images/hero-section/skill-dive/skill-dive.png'

export default {
  name: 'SkillDiveHeroSection',
  data() {
    return {
      skillDiveLogoBadge: skillDiveLogo,
    }
  },
  computed: {
    ...mapState({
      usersCurrentSubscriptions: state => state.subscriptions.usersCurrentSubscriptions,
    }),
    ...mapGetters({
      isBusinessUser: 'business/isBusinessUser',
    }),
    isSkillDivePreSalePage() {
      return this.$route.name === 'skill-dive'
    },
    skillDiveBadge() {
      return skillDiveIcon
    },
  },
}
</script>

<style lang="scss" scoped>
.skill-dive-hero {
  width: 100%;
  max-width: 1120px;
  padding: 50px 20px 20px 20px;
  color: var(--white);
  font-family: var(--font-regular);
  display: flex;
  overflow-x: clip;
  &--pt-80 {
    padding-top: 80px;
  }
  @include desktop {
    margin: 85px auto 105px auto;
    padding: 0;
  }
  &__content {
    width: 100%;
    display: flex;
    flex-flow: column;
    gap: 10px;
    &--mt-10 {
      margin-top: 10%;
      @include mobile {
        margin: 0;
        padding: 0;
      }
    }
    @include tablet-ipad-air-and-mini-portrait {
      font-size: rem(24px);
      line-height: rem(32px);
    }
    @include tablet {
      font-size: rem(24px);
      line-height: rem(32px);
    }
    @include desktop {
      width: 95%;
    }
  }
  &__logo {
    &-icon {
      width: 230px;
      @include tablet-ipad-air-and-mini-portrait {
        width: 260px;
      }
      @include tablet {
        width: 260px;
      }
      @include desktop {
        width: 325px;
      }
    }
  }
  &__title {
    font-family: var(--font-bold);
    font-size: rem(32px);
    line-height: rem(38px);
    font-style: normal;
    font-weight: 700;
    @include tablet-ipad-air-and-mini-portrait {
      font-size: rem(24px);
      line-height: rem(32px);
      margin-top: 20px;
    }
    @include tablet {
      font-size: rem(24px);
      line-height: rem(32px);
      margin-top: 20px;
    }
  }
  &__intro {
    font-size: rem(14px);
    font-weight: 450;
    line-height: rem(20px);
    @include tablet-ipad-air-and-mini-portrait {
      color: var(--light-blue-gray);
      font-size: rem(24px);
      line-height: rem(32px);
      width: 60%;
      margin-bottom: 20px;
    }
    @include tablet {
      color: var(--light-blue-gray);
      font-size: rem(24px);
      line-height: rem(32px);
      width: 60%;
      margin-bottom: 20px;
    }
    @include tablet {
      width: 100%;
    }
  }
  &__icon {
    position: relative;
    @include desktop {
      width: 100%;
    }
    &-img {
      position: absolute;
      top: -68%;
      right: -70px;
      width: 225px;
      @include tablet-ipad-air-and-mini-portrait {
        top: -50%;
        right: -170px;
        width: 455px;
      }
      @include tablet {
        top: -50%;
        right: -170px;
        width: 455px;
      }
      @include desktop {
        right: 0;
        width: 570px;
        &--top-65 {
          top: -65%;
        }
      }
    }
  }
}
</style>
